import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  .tab-custom .ant-tabs-tab .ant-tabs-tab-btn {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
  .ant-tabs-tab {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
  }

  .tab-custom {
    margin-top: 8px;
  }

  .business-manuals-sub-tabs {
    margin-top: 4px;
    margin-bottom: 16px;

    .ant-tabs-nav {
      margin-bottom: 16px;

      &::before {
        border-bottom: 1px solid #d0d7de !important;
      }
    }

    .ant-tabs-nav-list {
      display: flex;
      gap: 4px;
    }

    .ant-tabs-ink-bar {
      display: none !important;
    }

    .ant-tabs-tab {
      margin: 0 !important;
      padding: 0 16px !important;
      height: 36px !important;
      background-color: #e6e6e6 !important;
      border: 1px solid #d0d7de !important;
      border-radius: 4px 4px 0 0 !important;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      .ant-tabs-tab-btn {
        font-size: ${({ text_scale }) =>
          FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
        font-weight: 600;
        white-space: nowrap;
      }

      &:hover {
        background-color: #e5edf5;
      }

      &.ant-tabs-tab-active {
        background-color: #dbe4ef !important;
        border: 1px solid #c0cddc !important;
        border-top: 4px solid #183060 !important;
        border-radius: 4px 4px 0 0 !important;
        color: #183060 !important;
        position: relative;
        z-index: 2;

        .ant-tabs-tab-btn {
          color: #183060 !important;
          font-weight: 700;
          background: unset;
        }

        .text-muted-tab {
          color: #183060 !important;
          font-weight: 700;
        }
      }

      .text-muted-tab {
        color: #8c9ba5;
        font-weight: 500;
      }

      &.ant-tabs-tab-disabled {
        cursor: not-allowed;
        opacity: 0.8;

        .ant-tabs-tab-btn {
          color: #8c9ba5 !important;
          cursor: not-allowed;
          pointer-events: auto;
        }

        &:hover {
          background-color: #f0f4f8;
        }
      }
    }
  }
`;
